import type { Motivation } from '@hmawiw/shared';
import { useState } from 'react';
import { useT } from '../../i18n';
import { inboxCards, useBoardCards, useCards } from '../../store/cards';
import { useSettings } from '../../store/settings';
import { useUi } from '../../store/ui';
import controls from '../controls.module.css';
import { Inbox } from '../icons';
import { Sheet } from '../Sheet/Sheet';
import styles from './InboxTray.module.css';


/** Cards added on the go wait here until each gets a column; one tap on a column sorts one. */
export function InboxTray() {
  const t = useT();
  const cards = useBoardCards();
  const moveCard = useCards((s) => s.moveCard);
  const openSheet = useUi((s) => s.openSheet);
  const columnCount = useSettings((s) => s.columnCount);
  const COLUMNS = Array.from({ length: columnCount }, (_, i) => i as Motivation);
  const [open, setOpen] = useState(false);
  const list = inboxCards(cards);
  if (list.length === 0) return null;
  return (
    <>
      <div className={styles.bar} role="status" data-inbox="">
        <Inbox size={18} />
        <span className={styles.text}>{t.t('inbox.count', { n: list.length })}</span>
        <button type="button" className={`${controls.btn} ${controls.primary} ${styles.action}`} onClick={() => setOpen(true)}>
          {t.t('inbox.sort')}
        </button>
      </div>
      <Sheet open={open} label={t.t('inbox.title')} onClose={() => setOpen(false)}>
        <div className={controls.group}>
          <div className={controls.label}>{t.t('inbox.title')}</div>
          <p className={styles.hint}>{t.t('inbox.hint')}</p>
          <div className={styles.list}>
            {list.map((c) => (
              <div key={c.id} className={styles.row} data-inbox-card={c.id}>
                <button
                  type="button"
                  className={styles.title}
                  onClick={() => {
                    setOpen(false);
                    openSheet(c.id);
                  }}
                >
                  {c.title}
                </button>
                <div className={styles.chips} role="group" aria-label={t.t('add.column')}>
                  {COLUMNS.map((m) => (
                    <button key={m} type="button" className={styles.chip} style={{ '--m': `var(--m${m})` } as React.CSSProperties} aria-label={t.column(m)} title={t.column(m)} onClick={() => void moveCard(c.id, m, 1, 0, { cause: 'inbox' })}>
                      <span className={styles.dot} />
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className={controls.footer}>
          <button type="button" className={`${controls.btn} ${controls.primary}`} onClick={() => setOpen(false)}>
            {t.t('sheet.close')}
          </button>
        </div>
      </Sheet>
    </>
  );
}
